import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import LoggedSidebar from 'App/Shell/LoggedSidebar'
import { Alert } from 'loyal-react'
import { Individual, Company } from '.'
import Helmet from 'react-helmet'

class Profile extends Component {
  error = () =>
    this.props.participant.hasError ? (
      <Alert
        isError
        title='Ops! Não foi possível salvar as suas informações.'
        description='Tente novamente mais tarde.'
        className='pb-2'
      />
    ) : (
      ''
    )

  render () {
    return (
      <Fragment>
        <Helmet>
          <title>{`Meus dados - ${process.env.REACT_APP_TITLE || ''}`}</title>
        </Helmet>
        <div className='container-fluid px-0 bg-ui-4'>
          <div className='container pt-0 pb-4 py-md-4'>
            <div className='row'>
              <LoggedSidebar selected={this.props.location.pathname} count={0} />
              <div className='col-12 col-md-8 mt-0'>
                <div className='row'>
                  {this.error()}
                  <div className='col-12 border-color-ui-3 bg-white border radius'>
                    <div className='checkout-step row px-1 py-2 border-bottom border-color-ui-3 '>
                      <div className='col mr-auto'>
                        <h2 className='txt-title txt-font-body txt-initial color-title mr-auto'>
                          {this.props.participant.isCompany
                            ? 'Meus Dados'
                            : 'Informações Pessoais'}
                        </h2>
                      </div>
                    </div>
                    <div className='row px-0 pb-2 pt-half border-bottom border-color-ui-3'>
                      {this.props.participant.isCompany ? (
                        <Company {...this.props} />
                      ) : (
                        <Individual {...this.props} />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

Profile.propTypes = {
  location: PropTypes.shape({ pathname: PropTypes.string }).isRequired,
  participant: PropTypes.shape({
    isCompany: PropTypes.bool.isRequired,
    hasError: PropTypes.bool
  }).isRequired
}

export default Profile



// WEBPACK FOOTER //
// ./src/Participant/Profile/Profile.js